import React from 'react'
import { compose, pure } from 'recompose'
import { translate } from 'react-i18next'
import QS from 'query-string'
import axios from '../../redux/axios'
export class VerifyEmailRoute extends React.PureComponent {
  componentDidMount () {
    const { token } = QS.parse(window.location.search)
    if (!token) {
      return alert(
        'There was an error with your validation, please try again later'
      )
    }
    axios
      .post('/auth/refresh', { token })
      .then(response => {
        window.sessionStorage.setItem('token', response.data.token)
        window.history.replaceState({}, '', '/')
        window.location.reload()
      })
      .catch(e =>
        alert(
          'There was an error with your validation, please try again later: ' +
            e.message
        )
      )
  }
  render () {
    return (
      <center>
        <h3>Logging you in...</h3>
        <p>Please wait just a moment</p>
      </center>
    )
  }
}

VerifyEmailRoute.propTypes = {}

export default compose(pure, translate())(VerifyEmailRoute)



// WEBPACK FOOTER //
// ./src/routes/verifyEmail/verifyEmailRoute.js